import { TValueOfStringRecord } from '@interfaces/common/genericWithModifying';

export const ETreeTypeNode = {
	object: 'OBJECT',
	parameter: 'PARAMETER',
	arrayObjects: 'ARRAY_OBJECTS',
	array: 'ARRAY',
} as const;

export type TTreeTypeNode = TValueOfStringRecord<typeof ETreeTypeNode>
